import * as tf from '@tensorflow/tfjs';
import * as tmImage from '@teachablemachine/image';
import {save} from './saveTmModel.js'
import {toRaw} from 'vue'

export default class CustomTmImage{
    constructor(){
        this.model = null
        this._stopTraining = false
    }

    async train(labels, data, params = {
            denseUnits: 100,
            epochs: 50,
            learningRate: 0.001,
            batchSize: 16,
            imageSize: 224
        }, callback){

        this._stopTraining = false;
        let imagesize = params?.imageSize || 224 
        const model = await tmImage.createTeachable(
            { tfjsVersion: tf.version.tfjs, grayscale: false, imagesize },
            { version: 2 }
        )

        model.setLabels(labels)
        await this.addData(model, data)

        await model.train(params,            
            {
                onEpochEnd: async (epoch, logs) => {
                    const realEpoch = epoch + 1
                    callback(`Epoch: ${realEpoch} / ${params.epochs}`, realEpoch / params.epochs)
                    console.log("Epoch: ", realEpoch);

                    if (this._stopTraining) {
                        model.stopTraining().then(() => {
							console.log("Stopped training early");
                            callback(``, 1)
						});
                    }
                }
            }
        )
        model._metadata.modelName = 'tm-my-image-model'
        await this.loadRaw(model)
        return model
    }

    stopTraining(){
        this._stopTraining = true;
    }

    async save(){
        return await save(toRaw(this.model.model), this.model._metadata)
    }

    async addData(model, dataset){
        for(let i = 0; i < dataset.length; i++){
            for(let j = 0; j < dataset[i].length; j++){
                const image = dataset[i][j]
                await model.addExample(i, image)
            }
        }
    }

    async loadUrl({modelUrl, metadataUrl}){
        await this.loadRaw(Object.freeze(await tmImage.load(modelUrl, metadataUrl)))
    }

    async loadFile({modelFile, metadataFile, weightsFiles}){
        await this.loadRaw(Object.freeze(await tmImage.loadFromFiles(modelFile, weightsFiles[0], metadataFile)))
    }

    async loadRaw(model){
        const emptyCanvas = document.createElement('canvas');
        emptyCanvas.width = 224;
        emptyCanvas.height = 224;
        await model.predict(emptyCanvas)

        this.model = model;
    }

    async predict(canvas){
        return await this.model.predict(canvas)
    }

    async test(){
        const url = "https://teachablemachine.withgoogle.com/models/E3LQjZnW7/"
        const modelUrl = url + "model.json";
        const metadataUrl = url + "metadata.json";
        await this.loadUrl({modelUrl: modelUrl, metadataUrl: metadataUrl})
        return this
    }
}